import Crud from '../components/CategoryRecipe/Crud'
import Edit from '../components/CategoryRecipe/Edit'

let routes = {
    path: '/categoryRecipe',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {            
            path: '/categoryRecipe',
            component: Crud
        },
        {            
            path: '/categoryRecipe/edit/:id',
            component: Edit
        }
    ]        
}


export default routes


// WEBPACK FOOTER //
// ./src/router/categoryRecipe.js